export interface Product {
  id: string;
  name: string;
  slug: string;
  price: number;
  originalPrice?: number;
  image: string;
  description: string;
  category: string;
  isLimited: boolean;
  isNew: boolean;
  stock: number;
}

export const products: Product[] = [
  {
    id: 'prod-1',
    name: '萌白酱限定Q版兔耳手办',
    slug: 'limited-bunny-figure',
    price: 299,
    originalPrice: 399,
    image: 'https://readdy.ai/api/search-image?query=Cute%20kawaii%20anime%20style%20chibi%20figurine%20with%20pink%20bunny%20ears%2C%20detailed%20PVC%20figure%20on%20display%20stand%2C%20soft%20pastel%20colors%2C%20collectible%20toy%20photography%2C%20clean%20white%20background%2C%20professional%20product%20photography%2C%20high%20detail&width=600&height=600&seq=mengbai-prod-1&orientation=squarish',
    description: '15cm PVC手办，含可替换表情零件×3，独立编号收藏证书，限量3000体',
    category: '手办',
    isLimited: true,
    isNew: true,
    stock: 3000,
  },
  {
    id: 'prod-2',
    name: '萌白酱原创设计主题T恤——星之兔',
    slug: 'star-bunny-tshirt',
    price: 149,
    originalPrice: 199,
    image: 'https://readdy.ai/api/search-image?query=White%20cotton%20t-shirt%20with%20cute%20kawaii%20bunny%20and%20star%20illustration%20print%2C%20minimalist%20design%2C%20flat%20lay%20product%20photography%2C%20soft%20lighting%2C%20clean%20background%2C%20fashion%20apparel%20commercial%20photography&width=600&height=600&seq=mengbai-prod-2&orientation=squarish',
    description: '320g纯棉面料，原创兔子和星星图案设计，舒适透气，男女皆可穿着，尺码S-3XL',
    category: '服饰',
    isLimited: false,
    isNew: true,
    stock: 500,
  },
  {
    id: 'prod-3',
    name: '萌白酱亚克力立牌套装（五款入）',
    slug: 'acrylic-stand-set',
    price: 129,
    image: 'https://readdy.ai/api/search-image?query=Set%20of%20colorful%20kawaii%20acrylic%20standees%20with%20cute%20anime%20style%20characters%2C%20displayed%20on%20desk%2C%20transparent%20material%2C%20pastel%20colors%2C%20collectible%20merchandise%2C%20professional%20product%20photography%2C%20clean%20background&width=600&height=600&seq=mengbai-prod-3&orientation=squarish',
    description: '精选五款人气造型，高透明度亚克力材质，背面印制亲笔签名，适合桌面装饰和收藏',
    category: '立牌',
    isLimited: false,
    isNew: false,
    stock: 1000,
  },
  {
    id: 'prod-4',
    name: '萌白酱主题徽章盲盒套装（10枚入）',
    slug: 'badge-blind-box',
    price: 89,
    originalPrice: 119,
    image: 'https://readdy.ai/api/search-image?query=Collection%20of%20cute%20colorful%20enamel%20pins%20and%20badges%20with%20kawaii%20designs%2C%20displayed%20in%20gift%20box%2C%20pastel%20pink%20and%20cream%20tones%2C%20collectible%20items%2C%20professional%20product%20photography%2C%20clean%20white%20background&width=600&height=600&seq=mengbai-prod-4&orientation=squarish',
    description: '10枚入含2枚隐藏款，珐琅工艺制作，安全别针设计，可佩戴于背包衣物等',
    category: '徽章',
    isLimited: false,
    isNew: false,
    stock: 800,
  },
  {
    id: 'prod-5',
    name: '萌白酱限定挂画——花火之约',
    slug: 'limited-wall-scroll-sparkle',
    price: 199,
    image: 'https://readdy.ai/api/search-image?query=Elegant%20fabric%20wall%20scroll%20with%20beautiful%20anime%20style%20illustration%2C%20colorful%20vibrant%20artwork%2C%20displayed%20on%20wall%2C%20decorative%20home%20decor%2C%20warm%20lighting%2C%20professional%20product%20photography%2C%20high%20quality%20print&width=600&height=600&seq=mengbai-prod-5&orientation=squarish',
    description: 'B2尺寸优质缎面挂画，萌白酱花火造型限定插画，附铝合金挂轴，限量1000幅',
    category: '挂画',
    isLimited: true,
    isNew: true,
    stock: 1000,
  },
  {
    id: 'prod-6',
    name: '萌白酱主题手机壳——兔耳猫耳双款',
    slug: 'phone-case-bunny-cat',
    price: 69,
    originalPrice: 89,
    image: 'https://readdy.ai/api/search-image?query=Cute%20kawaii%20phone%20case%20with%20bunny%20and%20cat%20ear%20design%2C%20pastel%20pink%20and%20cream%20colors%2C%20displayed%20on%20minimalist%20surface%2C%20fashion%20accessory%20photography%2C%20soft%20lighting%2C%20clean%20background%2C%20commercial%20product%20photography&width=600&height=600&seq=mengbai-prod-6&orientation=squarish',
    description: '萌白酱原创兔耳/猫耳双款设计，支持iPhone和主流安卓机型，TPU防摔材质',
    category: '数码配件',
    isLimited: false,
    isNew: false,
    stock: 600,
  },
];

export const getAllProducts = (): Product[] => products;

export const getLimitedProducts = (): Product[] => {
  return products.filter((p) => p.isLimited);
};